import { useQuery } from "@tanstack/react-query";

import { UsersListResponse } from "@/@types/growthos-api/schema/openapi";
import { NEST_BACKEND_URL } from "@/lib/axios";
import { QueryConfig } from "@/lib/react-query";
import { axiosApi } from "@/Utils";

export const getAllUsers = async (): Promise<UsersListResponse> => {
  const response = await axiosApi.get(`/api/team/users`, {
    baseURL: NEST_BACKEND_URL,
    cache: false,
  });
  return response as unknown as UsersListResponse;
};

type QueryFnType = typeof getAllUsers;

type UseGetAllUsersOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllUsers = ({ config }: UseGetAllUsersOptions = {}) => {
  return useQuery({
    ...config,
    queryKey: ["team-users"],
    queryFn: getAllUsers,
    staleTime: 0, // Always consider data stale to allow immediate refetch
  });
};
